import { useEffect, useState, useRef } from 'react';
import { FormInstance } from 'ebs-design';

export function useWatch<T = any>(
  form: FormInstance,
  name: string | number | (string | number)[],
): T {
  const [value, setValue] = useState<T>(() => form.getFieldValue(name));
  const valueRef = useRef<T>(value);

  useEffect(() => {
    const initialValue = form.getFieldValue(name);
    setValue(initialValue);
    valueRef.current = initialValue;

    const unsubscribe = (form as any).getInternalHooks?.('HOOK_MARK')?.useSubscribe?.(true);

    const interval = setInterval(() => {
      const currentValue = form.getFieldValue(name);
      if (JSON.stringify(currentValue) !== JSON.stringify(valueRef.current)) {
        setValue(currentValue);
        valueRef.current = currentValue;
      }
    }, 100);

    return () => {
      clearInterval(interval);
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [form, name]);

  return value;
}

export function useWatchCallback<T = any>(
  form: FormInstance,
  name: string | number | (string | number)[],
): T {
  const [value, setValue] = useState<T>(() => form.getFieldValue(name));

  useEffect(() => {
    const initialValue = form.getFieldValue(name);
    setValue(initialValue);

    const originalOnValuesChange = (form as any).__onValuesChange;

    (form as any).__onValuesChange = (changedValues: any, allValues: any) => {
      const fieldName = Array.isArray(name) ? name.join('.') : name;
      if (changedValues[fieldName] !== undefined) {
        setValue(changedValues[fieldName]);
      }

      if (originalOnValuesChange) {
        originalOnValuesChange(changedValues, allValues);
      }
    };

    return () => {
      (form as any).__onValuesChange = originalOnValuesChange;
    };
  }, [form, name]);

  return value;
}
